/**
 * Support the legacy progress loader until it's replaced by the default Nuxt loader.
 */
import Vue from 'vue'
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
    color: '#54a9ec',
    failedColor: '#ff7777',
    thickness: '4px',
})
